import React, { useEffect, useState } from "react";
import { studySiteDataEntryServices } from "../../../../../APIServices/studySiteDataEntryServices";
import PrintSchemaFormReport from "./PrintSchemaFormReport";

const ViewSchemaFormReportList = ({ formData, schemaName }) => {
  const [totalDataEntry, setTotalDataEntry] = useState([]);
  let totalOptionId = []

  useEffect(() => {
    setTotalDataEntry([])
  }, []);

  totalDataEntry?.forEach(item => {
    if (item && typeof item === "object") {
      if (Array.isArray(item.value)) {
        item.value.forEach(v => {
          if (v?.id) totalOptionId.push(Number(v.id));
        });
      } else if (item?.id) {
        totalOptionId.push(Number(item.id));
      }
    }
  });

  const valueRanderFunction = (id) => {
    return totalDataEntry?.find(item => item.fieldId === id) || ""
  }

  const tempFieldCache = {};

  const handleNumberChange = (fieldId, type, newValue, wholeNumber, floatNumber) => {
    if (type === "value") {
      let regex;
      if (wholeNumber) {
        regex = /^-?\d*$/;
      } else if (floatNumber) {
        regex = /^-?\d*(\.\d*)?$/;
      } else {
        return;
      }
      if (!regex.test(newValue)) return;
    }
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: "number",
        [type]: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const finalValue = type === "value" ? newValue : updatedItem.value;
      const finalUnit = type === "unit" ? newValue : updatedItem.unit;
      const finalUnitType = type === "unitType" ? newValue : updatedItem.unitType;

      if ((finalValue !== "" && finalValue != null) || (finalUnit !== "" && finalUnit != null) || (finalUnitType !== "" && finalUnitType != null)) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleCustomNumberChange = (fieldId, type, newValue, wholeNumber, floatNumber, disable) => {
    if (type === "value") {
      let regex;
      if (wholeNumber) {
        regex = /^-?\d*$/;
      } else if (floatNumber) {
        regex = /^-?\d*(\.\d*)?$/;
      } else {
        return;
      }
      if (!regex.test(newValue)) return;
    }

    if (!tempFieldCache[fieldId]) {
      const existing = totalDataEntry.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...existing, fieldId, type: "customNumber" };
    }

    tempFieldCache[fieldId][type] = newValue;

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      value,
      unit,
      unitType,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (value != null && value !== "") ||
      (unit != null && unit !== "") ||
      (unitType != null && unitType !== "") ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    setTotalDataEntry(prev => {
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (hasAnyValue) {
        filtered.push(tempFieldCache[fieldId]);
      }
      return filtered;
    });
  };

  const handleTextChange = (fieldId, type, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: "text",
        [type]: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const finalValue = type === "value" ? newValue : updatedItem.value;
      const finalUnit = type === "unit" ? newValue : updatedItem.unit;
      const finalUnitType = type === "unitType" ? newValue : updatedItem.unitType;
      if (finalValue !== "" && finalValue != null || finalUnit !== "" && finalUnit != null || finalUnitType !== "" && finalUnitType != null) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleCustomTextChange = (fieldId, type, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const existing = totalDataEntry.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...existing, fieldId, type: "customText" };
    }

    tempFieldCache[fieldId][type] = newValue;

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      value,
      unit,
      unitType,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (value != null && value !== "") ||
      (unit != null && unit !== "") ||
      (unitType != null && unitType !== "") ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    setTotalDataEntry(prev => {
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (hasAnyValue) {
        filtered.push(tempFieldCache[fieldId]);
      }
      return filtered;
    });
  };

  const handleDateChange = (fieldId, typeOrObject, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      let updatedItem = {
        ...existing,
        fieldId,
        type: "date",
      };
      if (typeof typeOrObject === 'object') {
        updatedItem = {
          ...updatedItem,
          ...typeOrObject,
        };
      } else {
        updatedItem[typeOrObject] = newValue;
      }
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const { day, month, year } = updatedItem;
      if (
        (day !== "" && day != null) ||
        (month !== "" && month != null) ||
        (year !== "" && year != null)
      ) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleCustomDateChange = (fieldId, typeOrObject, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const existing = totalDataEntry.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...existing, fieldId, type: "customDate" };
    }

    if (typeof typeOrObject === 'object') {
      tempFieldCache[fieldId] = {
        ...tempFieldCache[fieldId],
        ...typeOrObject,
      };
    } else {
      tempFieldCache[fieldId][typeOrObject] = newValue;
    }

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      day,
      month,
      year,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (day != null && day !== "") ||
      (month != null && month !== "") ||
      (year != null && year !== "") ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    setTotalDataEntry(prev => {
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (hasAnyValue) {
        filtered.push(tempFieldCache[fieldId]);
      }
      return filtered;
    });
  };

  const handleTimeChange = (fieldId, type, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: "time",
        [type]: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const finalHour = type === "hour" ? newValue : updatedItem.hour;
      const finalMinute = type === "minute" ? newValue : updatedItem.minute;
      const finalSecond = type === "second" ? newValue : updatedItem.second;
      const finalFormat = type === "format" ? newValue : updatedItem.format;
      if (finalHour !== "" && finalHour != null || finalMinute !== "" && finalMinute != null || finalSecond !== "" && finalSecond != null || finalFormat !== "" && finalFormat != null) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleCustomTimeChange = (fieldId, type, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const existing = totalDataEntry.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...existing, fieldId, type: "customTime" };
    }

    tempFieldCache[fieldId][type] = newValue;

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      hour,
      minute,
      second,
      format,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (hour != null && hour !== "") ||
      (minute != null && minute !== "") ||
      (second != null && second !== "") ||
      (format != null && format !== "") ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    setTotalDataEntry(prev => {
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (hasAnyValue) {
        filtered.push(tempFieldCache[fieldId]);
      }
      return filtered;
    });
  };

  const handleTextareaChange = (fieldId, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: "textarea",
        value: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (newValue !== "" && newValue != null) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleRangeScoreChange = (fieldId, fieldType, type, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: fieldType,
        [type]: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const finalValue = type === "value" ? newValue : updatedItem.value;
      const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
      if ((finalValue !== "" && finalValue != null) ||
        (finalValueRemark !== "" && finalValueRemark != null)) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const checkConditionalFunction = (fieldId, optionId) => {
    // let checkFieldConditionalId = [...new Set(formFields?.filter(item => item.id === fieldId)?.map(item => item.conditionalFields).filter(Boolean).flat())]
    // let conditionalOptionId = checkFieldConditionalId.filter(item => item.includes(optionId));
    // let conditionalFieldId = conditionalOptionId?.map(id => Number(id.split('_')[0]))
    // if (conditionalFieldId?.length > 0) {
    //   return totalDataEntry?.filter(item => !conditionalFieldId?.includes(item.fieldId))
    // } else {
    //   return [...totalDataEntry]
    // }
  }

  const handleDropdownRadioChange = (fieldId, optionId, type, newValue) => {
    let finalDataEntry = checkConditionalFunction(fieldId, optionId)
    const existing = finalDataEntry?.find(item => item.fieldId === fieldId) || {};
    const updatedItem = {
      ...existing,
      fieldId,
      type: "dropdownRadio",
      [type]: newValue,
    };
    if (type === "value") {
      updatedItem.id = optionId
    }
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId);
    const finalValue = type === "value" ? newValue : updatedItem.value;
    const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
    if ((finalValue !== "" && finalValue != null) ||
      (finalValueRemark !== "" && finalValueRemark != null)) {
      filtered.push(updatedItem);
    }
    setTotalDataEntry(filtered)
  };

  const handleScaleChange = (fieldId, optionId, type, newValue) => {
    let finalDataEntry = checkConditionalFunction(fieldId, optionId)
    const existing = finalDataEntry?.find(item => item.fieldId === fieldId) || {};
    const updatedItem = {
      ...existing,
      fieldId,
      type: "scale",
      [type]: newValue,
    };
    if (type === "value") {
      updatedItem.id = optionId
    }
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId);
    const finalValue = type === "value" ? newValue : updatedItem.value;
    const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
    if ((finalValue !== "" && finalValue != null) ||
      (finalValueRemark !== "" && finalValueRemark != null)) {
      filtered.push(updatedItem);
    }
    setTotalDataEntry(filtered)
  };

  const handleUploadChange = async (fieldId, type, newValue) => {
    let uploadedFile
    const formData = new FormData();
    if (type === "value") {
      formData.append("file", newValue);
      uploadedFile = await studySiteDataEntryServices.uploadDocumentData(formData);
    }
    const existing = totalDataEntry?.find(item => item.fieldId === fieldId) || {};
    const updatedItem = {
      ...existing,
      fieldId,
      type: "file",
      value: type === "value" ? (uploadedFile?.data || "") : existing?.value || "",
      valueRemark: type === "valueRemark" ? newValue : existing?.valueRemark || "",
    };
    const filtered = totalDataEntry.filter(item => item.fieldId !== fieldId);
    const finalValue = type === "value" ? newValue : updatedItem.value;
    const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
    if ((finalValue !== "" && finalValue != null) ||
      (finalValueRemark !== "" && finalValueRemark != null)) {
      filtered.push(updatedItem);
    }
    setTotalDataEntry(filtered)
  };

  const handleCustomDropdownRadioChange = (fieldId, optionId, type, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const base = checkConditionalFunction(fieldId, optionId)?.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...base };
    }

    tempFieldCache[fieldId] = {
      ...tempFieldCache[fieldId],
      fieldId,
      type: "customDropdownRadio",
      [type]: newValue,
    };

    if (type === "value") {
      tempFieldCache[fieldId].id = optionId;
    }

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      value,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (value !== "" && value != null) ||
      (referenceRangeLowerLimit !== "" && referenceRangeLowerLimit != null) ||
      (referenceRangeLowerLimitEntryType !== "" && referenceRangeLowerLimitEntryType != null) ||
      (referenceRangeUpperLimit !== "" && referenceRangeUpperLimit != null) ||
      (referenceRangeUpperLimitEntryType !== "" && referenceRangeUpperLimitEntryType != null) ||
      (referenceRangeIndicator !== "" && referenceRangeIndicator != null) ||
      (clinicalSignificance !== "" && clinicalSignificance != null) ||
      (remark !== "" && remark != null);

    let finalDataEntry = checkConditionalFunction(fieldId, optionId);
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId) || [];

    if (hasAnyValue) {
      filtered.push(tempFieldCache[fieldId]);
    }

    setTotalDataEntry(filtered);
  };

  const handleCheckboxChange = (fieldId, optionId, type, newValue) => {
    let finalDataEntry = checkConditionalFunction(fieldId, optionId)
    const existing = finalDataEntry?.find(item => item.fieldId === fieldId) || { fieldId, value: [] };
    const updatedValueArray = Array.isArray(existing.value) ? [...existing.value] : [];
    const existingIndex = updatedValueArray.findIndex(
      item => item.id === optionId && item.value === newValue
    );
    if (existingIndex > -1) {
      updatedValueArray.splice(existingIndex, 1);
    } else {
      updatedValueArray.push({ id: optionId, value: newValue });
    }
    const updatedItem = {
      ...existing,
      fieldId,
      type: "checkbox",
      [type]: type === "value" ? updatedValueArray : newValue,
    };
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId);
    const finalValue = type === "value" ? updatedValueArray : updatedItem.value;
    const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
    if (finalValue.length > 0 || (finalValueRemark !== "" && finalValueRemark != null)) {
      filtered.push(updatedItem);
    }
    setTotalDataEntry(filtered)
  };

  const handleCustomCheckboxChange = (fieldId, optionId, type, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const existing = checkConditionalFunction(fieldId, optionId)?.find(item => item.fieldId === fieldId) || {
        fieldId,
        value: [],
      };
      tempFieldCache[fieldId] = { ...existing };
    }

    const updatedValueArray = Array.isArray(tempFieldCache[fieldId].value)
      ? [...tempFieldCache[fieldId].value]
      : [];

    const existingIndex = updatedValueArray.findIndex(
      (item) => item.id === optionId && item.value === newValue
    );

    if (existingIndex > -1) {
      updatedValueArray.splice(existingIndex, 1);
    } else {
      updatedValueArray.push({ id: optionId, value: newValue });
    }

    tempFieldCache[fieldId] = {
      ...tempFieldCache[fieldId],
      fieldId,
      type: "customCheckbox",
      [type]: type === "value" ? updatedValueArray : newValue,
    };

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      value,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (Array.isArray(value) && value.length > 0) ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    const finalDataEntry = checkConditionalFunction(fieldId, optionId);
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId) || [];

    if (hasAnyValue) {
      filtered.push(tempFieldCache[fieldId]);
    }

    setTotalDataEntry(filtered);
  };

  function convertTo24(timeStr) {
    const [time, modifier = "AM"] = timeStr.split(" ");
    let [hours, minutes, seconds] = time.split(":");

    hours = parseInt(hours, 10);
    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    return `${hours.toString().padStart(2, "0")}:${minutes}:${seconds}`;
  }

  const handleDownload = () => {
    // const jsonString = JSON.stringify(formFields, null, 2);
    // const blob = new Blob([jsonString], { type: 'application/json' });
    // const url = URL.createObjectURL(blob);

    // const link = document.createElement('a');
    // link.href = url;
    // link.download = `${formName}.json`;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);

    // URL.revokeObjectURL(url);
  };

  return (
    <>
      <PrintSchemaFormReport
        formData={formData}
        schemaName={schemaName}
        handleDownload={handleDownload}
        totalOptionId={totalOptionId}
        valueRanderFunction={valueRanderFunction}
        handleNumberChange={handleNumberChange}
        handleCustomNumberChange={handleCustomNumberChange}
        handleTextChange={handleTextChange}
        handleCustomTextChange={handleCustomTextChange}
        handleDateChange={handleDateChange}
        handleCustomDateChange={handleCustomDateChange}
        handleTimeChange={handleTimeChange}
        handleCustomTimeChange={handleCustomTimeChange}
        handleTextareaChange={handleTextareaChange}
        handleDropdownRadioChange={handleDropdownRadioChange}
        convertTo24={convertTo24}
        handleCustomDropdownRadioChange={handleCustomDropdownRadioChange}
        handleRangeScoreChange={handleRangeScoreChange}
        handleScaleChange={handleScaleChange}
        handleUploadChange={handleUploadChange}
        handleCheckboxChange={handleCheckboxChange}
        handleCustomCheckboxChange={handleCustomCheckboxChange}
      />
    </>
  );
};

export default ViewSchemaFormReportList;
